import { BlocksView } from '@modules/Nzo.CMS/Frontend/libraries/cmsPage/blocks/blocks.template'
import { Img } from '@shared/Frontend/components/img'
import { useInView } from '@shared/Frontend/hooks/useInView'
import { cn } from '@shared/Frontend/utils/addToClassName'
import React from 'react'
import { BlockActions } from '../shared/blockActions'
import { BlockHeader } from '../shared/blockHeader'

export const TextWithImageBlock: BlocksView['TextWithImageBlock'] = (props) => {
  const { id, text, imagePosition, image } = props
  const { inView, ref } = useInView({ threshold: 0.1 })
  return (
    <section
      id={id}
      ref={ref}
      className={cn(`block block--textimage textimage--image-${imagePosition} ls-spacing`, inView && 'inview')}
    >
      <div className="block__inner ls-container ls-gutter">
        <div className="block__layout gridsys--columns">
          {image && (
            <div className="block__visual gridsys--50p">
              <Img {...image} loading="lazy" className="block__image" width="592" height="333" sizes="(min-width: 1440px) 592px, (min-width: 1024px) 45w, 90vw" />
            </div>
          )}

          <div className="block__content gridsys--50p">
            <BlockHeader {...props} />

            {text && <div className="block__text text--styled" dangerouslySetInnerHTML={{ __html: text }} />}

            <BlockActions {...props} datalayerCategory="textimage_block" />
          </div>
        </div>
      </div>
    </section>
  )
}
